<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo"> 
      <i class="fas fa-users-cog icon"></i>
        Termino y Condiciones
      </div>
      
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul> 
            <li>
              <router-link :to="{name:'administrativeHome'}" >
                <span >
                  <i class="fas fa-home icon"></i>                  
                   inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{name: 'terminoCondiciones'}">
                <span>
                 <i class="fas fa-user-cog icon"></i>
                  Termino y Condiciones
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <div class="box">

          <createTerm 
          v-if="isComponentModalActive"
          :isComponentModalActive="isComponentModalActive"
          :closeBasic="closeBasic"
          :chargeTermsList="chargeTermsList"
          :term_id="term_id">
          </createTerm>
          <b-button type="is-primary is-small" @click="openBasic()">Crear Termino y Condiciones</b-button>

          <b-table type="is-primary"
            :data.sync="listTerm"
            :loading="loading"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :is-fullwidth="true"
            default-sort="stablishment.name"
            aria-next-label="Next page"            
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="name" label="Nombre">{{ props.row.title }}</b-table-column>

              <b-table-column label="Action">
                        <b-button type="is-primary is-small" @click="editBasic(props.row.id)">Editar</b-button>

              </b-table-column>
            </template>
          </b-table>
          
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from '../../../../template/PlantillaContenido'
import createTerm from '../../../../components/administrative/manteiners/term/create';

export default {
  components: {
    PlantillaContenido,
    createTerm
  },
  data() {
    return {
      term_id: null,
      listTerm: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5
    };
  },
  mounted: function() {
    this.chargeTermsList();
  },
  methods: {
    openBasic() {
      this.isComponentModalActive = true;
    },
    closeBasic() {
      this.term_id = null;
      this.isComponentModalActive = false;
    },
    editBasic(id) {
      this.term_id = id;
      this.isComponentModalActive = true;
    },
    chargeTermsList() {
      this.loading = true;
      this.listTerm = [];
      this.$http.get(`api/${localStorage.getItem('perfil')}/term`).then(
        response => {
          this.listTerm = response.body.data;          
          this.loading = false;
        },
        response => {
          console.log("error: ", response);
        }
      );
    }
  },
  
};
</script>

